import React from 'react';

import { ReactComponent as IconAmex } from './resources/AMEX.svg';
import { ReactComponent as IconBancontact } from './resources/Bancontact.svg';
import { ReactComponent as IconCb } from './resources/CB.svg';
import { ReactComponent as IconKlarna } from './resources/Klarna.svg';
import { ReactComponent as IconMaestro } from './resources/Maestro.svg';
import { ReactComponent as IconMasterCard } from './resources/Mastercard.svg';
import { ReactComponent as IconVisa } from './resources/VISA.svg';
import IconDinersClub from './resources/DinersClub.png';
import { ReactComponent as IconDiscover } from './resources/Discover.svg';

function imgFor(src) {
    // svg images are converted to react components by webpack
    // for bitmap images we need to use a img element
    return props => <img {...props} src={src} />;  // eslint-disable-line jsx-a11y/alt-text, react/display-name
}

export const PAYMENT_METHOD_ICON_COMPONENT_MAPPING = {
    AMEX: IconAmex,
    Visa: IconVisa,
    MasterCard: IconMasterCard,
    CB: IconCb,
    Klarna: IconKlarna,
    Maestro: IconMaestro,
    Bancontact: IconBancontact,
    DinersClub: imgFor(IconDinersClub),
    Discover: IconDiscover
};
